import { createFileRoute } from '@tanstack/react-router';
import StudentManagement from '../../../components/portals/StudentManagement';
import { useManagersPortal } from '../../../contexts/ManagersPortalContext';

export const Route = createFileRoute('/portal/managers/')({
  component: ManagersStudentsContent,
});

function ManagersStudentsContent() {
  const {
    students,
    isStudentsLoading,
    saveStudent,
    deleteStudent,
    classes,
    attendanceRecords,
    handleAttendanceUpdate,
    teachers,
    payments,
    setPayments,
    assignStudentsToClass,
    schoolYears,
    selectedSchoolYearId,
    setSelectedSchoolYearId,
  } = useManagersPortal();

  return (
    <StudentManagement
      students={students}
      isLoading={isStudentsLoading}
      onSaveStudent={saveStudent}
      onDeleteStudent={deleteStudent}
      classes={classes}
      attendanceRecords={attendanceRecords}
      onAttendanceUpdate={handleAttendanceUpdate}
      teachers={teachers}
      payments={payments}
      onPaymentsChange={setPayments}
      onAssignStudentsToClass={assignStudentsToClass}
      schoolYears={schoolYears}
      selectedSchoolYearId={selectedSchoolYearId}
      onSelectSchoolYear={setSelectedSchoolYearId}
    />
  );
}
